import { useEffect, useRef, useState } from "react";
import { useTenders } from "../../../../tools/api";
import styles from "./winner.module.scss";
import { Button, Col, List, Row } from "antd";
import { complexDigitToman, delay, isEmpty } from "../../../../tools/tools";
import TimeDown from "../../../../components/timedown/timedown";
import { useNavigate, useSearchParams } from "react-router-dom";
import { _adr } from "../../../../address";
import InCreaseWallet from "../../../../components/increaseWallet/InCreaseWallet";
import { useLayouts } from "../../../layout/layouts";
import Loading from "../../../../components/loader/loading";
const Winner = () => {
  const nav = useNavigate();
  const { queryCurrentUserBids, paidBidTenderByCustomer } = useTenders();
  const [isLoadingList, setIsLoadingList] = useState(true);

  const [searchParam] = useSearchParams();

  const { refreshUser, checkLoginUser } = useLayouts();

  const [bTable, setBTable] = useState([]);
  //state current page show Records
  const [currentPage, setCurrentPage] = useState(0);
  // state totalRecord
  const [totalRecord, setTotalRecord] = useState(0);

  //check Login
  const [isLogin, setLogin] = useState();

  //user Info
  const [user, setUser] = useState({});

  useEffect(() => {
    const checkLogin = async () => {
      const isCheck = await checkLoginUser();
      if (isCheck) {
        setLogin(isCheck);
        const userInfo = await refreshUser();
        setUser(userInfo || {});
      }
    };
    checkLogin();
  }, [checkLoginUser, refreshUser]);

  const [openIncress, setOpenIncress] = useState(false);
  const [localInvoiceId, setLocalInvoiceId] = useState("");
  const [amountCharge, setAmountCharge] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const bankRef = useRef("");

  useEffect(() => {
    if (!isEmpty(searchParam.get("localInvoiceId"))) {
      const getLocalInvoiceID = searchParam.get("localInvoiceId");
      setLocalInvoiceId(getLocalInvoiceID);
      setOpenIncress(true);
    }
  }, []);

  const handleCallBackCharge = (value) => {
    setIsLoading(true);
    if (value?.length > 0) {
      bankRef.current.innerHTML = value;
      document.querySelector('form[action="https://asan.shaparak.ir"]').submit();
    } else {
      setLocalInvoiceId("");
      setOpenIncress(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    initialData();
  }, [currentPage]);

  const initialData = async () => {
    try {
      setIsLoadingList(true);
      let payload = {
        searchconfigmodel: {
          sort: "",
          filter: "",
          entriesperpage: 10,
          page: currentPage === 0 ? 0 : currentPage - 1,
          totalrowcount: 0,
        },
        auctionstatus: [0, 3, 6],
      };
      const response = await queryCurrentUserBids(payload);
      if (response && !response?.HasError) {
        const temp = response?.Result.filter((item) => item.hasWon);
        setBTable(temp);
        setTotalRecord(response?.searchconfigmodel?.totalrowcount);
      }
      setIsLoadingList(false);
    } catch (error) {
      console.error(error);
      setIsLoadingList(false);
    }
  };

  const switchTagBag = (type = 0) => {
    switch (type) {
      case 0:
        return "gold";
      case 1:
        return "platinum";
      case 2:
        return "silver";
      case 3:
        return "bronze";
      case 4:
        return "aptel";
      default:
        return "";
    }
  };

  const handlePayment = async (item) => {
    try {
      if (user?.walletAmount - (item?.userBid - item?.tenderDeposit) >= 0) {
        setIsLoading(true);
        const payLoad = {
          auctionid: item?.auctionProductId,
        };
        const paymentBid = await paidBidTenderByCustomer(payLoad);
        if (paymentBid) {
          await delay(3000);
          initialData();
        }
        setIsLoading(false);
      } else {
        setAmountCharge(Math.abs(user?.walletAmount - (item?.userBid - item?.tenderDeposit)));
        setOpenIncress(true);
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className={styles.winner_container}>
        <div className={styles.holder_list}>
          <List
            itemLayout="vertical"
            size="large"
            loading={isLoadingList}
            pagination={{
              onChange: (page) => {
                setCurrentPage(page);
              },
              hideOnSinglePage: true,
              pageSize: 10,
              total: totalRecord,
              current: currentPage === 0 ? 1 : currentPage,
              showSizeChanger: false,
            }}
            dataSource={bTable}
            renderItem={(item, key) => (
              <div key={key} className={styles.card_holder}>
                {item.auctionStatus === 3 ? (
                  <>
                    <div className={styles.header}>
                      <div className={styles.row_header}>
                        <div className={styles.text}> مهلت پرداخت</div>
                        <div className={styles.timer}>
                          <TimeDown datetime={new Date(new Date(item?.endDate).setHours(48))} noText />
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.card} ${styles.cardwithHeader}`}>
                      <div className={styles.row_card}>
                        <div className={styles.text_card}>
                          <ul>
                            <li>
                              <div className={styles.label}>قیمت پیشنهادی شما:</div>
                              <div className={styles.value}>
                                <span dir="ltr">{complexDigitToman(item?.userBid)}</span> تومان
                              </div>
                            </li>
                            <li>
                              <div className={styles.label}>ودیعه:</div>
                              <div className={styles.value}>
                                <span dir="ltr">{complexDigitToman(item?.tenderDeposit)}</span> تومان
                              </div>
                            </li>
                            <li>
                              <div className={styles.label}>مبلغ قابل پرداخت:</div>
                              <div className={styles.value}>
                                <span dir="ltr">{complexDigitToman(Math.abs(item?.tenderDeposit - item?.userBid))}</span> تومان
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className={styles.sim_card}>
                          <div className={styles.hold_img}>
                            <img src={process.env.PUBLIC_URL + "/assets/images/sim.png"} alt="" />
                            <div className={styles.msisdn}>{item?.auctionTitle}</div>
                            <div className={styles.tag} data-type={switchTagBag(item?.auctionProductTypeId)}>
                              {item?.auctionProductType}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.holder_footer}>
                        <div className={styles.text}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                              d="M12 2.25C6.62402 2.25 2.25 6.62402 2.25 12C2.25 17.376 6.62402 21.75 12 21.75C17.376 21.75 21.75 17.376 21.75 12C21.75 6.62402 17.376 2.25 12 2.25ZM12 3.75C16.5645 3.75 20.25 7.43555 20.25 12C20.25 16.5645 16.5645 20.25 12 20.25C7.43555 20.25 3.75 16.5645 3.75 12C3.75 7.43555 7.43555 3.75 12 3.75ZM11.25 7.5V13.5H12.75V7.5H11.25ZM11.25 15V16.5H12.75V15H11.25Z"
                              fill="#A0A0A0"
                            />
                          </svg>
                          درصورت عدم پرداخت در مهلت مقرر شده، ودیعه شما ضبط خواهد شد.
                        </div>
                        <div className={`holder-button ${styles.action}`}>
                          <Button className={`btn-green`} onClick={(e) => handlePayment(item)}>
                            پرداخت
                          </Button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={styles.card}>
                      <div className={styles.row_card}>
                        <div className={styles.text_card}>
                          <ul>
                            <li>
                              <div className={styles.label}>قیمت شروع:</div>
                              <div className={styles.value}>
                                <span dir="ltr">{complexDigitToman(item?.startPrice)}</span> تومان
                              </div>
                            </li>
                            <li>
                              <div className={styles.label}>تعداد شرکت کنندگان:</div>
                              <div className={styles.value}>
                                <span>{item?.countBidders}</span>
                              </div>
                            </li>
                            <li>
                              <div className={styles.label}>تعداد پیشنهادها:</div>
                              <div className={styles.value}>
                                <span>{item?.counBids}</span>
                              </div>
                            </li>
                            <li>
                              <div className={`${styles.label}`}>وضعیت:</div>
                              <div className={`${styles.value} ${styles.green}`}>
                                <span>{item?.auctionStatus === 0 ? " پرداخت شده-در انتظار فعالسازی" : "پرداخت شده-فعال"}</span>
                              </div>
                            </li>
                            <li>
                              <div className={styles.label}>قیمت پیشنهادی شما:</div>
                              <div className={styles.value}>
                                <span dir="ltr">{complexDigitToman(item?.userBid)}</span> تومان
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className={styles.sim_card}>
                          <div className={styles.hold_img}>
                            <img src={process.env.PUBLIC_URL + "/assets/images/sim.png"} alt="" />
                            <div className={styles.msisdn}>{item?.auctionTitle}</div>
                            <div className={styles.tag} data-type={switchTagBag(item?.auctionProductTypeId)}>
                              {item?.auctionProductType}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
          />
        </div>
      </div>
      <InCreaseWallet
        open={openIncress}
        planid={process.env.REACT_APP_INCREASE_WINNER}
        msisdn={user?.telnoone}
        localInvoiceId={localInvoiceId}
        price={amountCharge}
        callback={handleCallBackCharge}
        activePrice={true}
      />
      <div ref={bankRef}></div>
      <Loading isOpen={isLoading} />
    </>
  );
};

export default Winner;
